import { useState, useEffect } from "react";
import { themeColors } from "./../utils/themeColors";

// Helper to get the selected theme
const getSelectedTheme = () => {
  const savedTheme = localStorage.getItem("themeData");
  const defaultTheme = themeColors.find((t) => t.id === "theme1");
  return savedTheme ? JSON.parse(savedTheme) : defaultTheme;
};

// ================== usePrimaryColor ==================
export const usePrimaryColor = () => {
  const [primaryColor, setPrimaryColor] = useState(() => getSelectedTheme().Primary);

  useEffect(() => {
    const updateTheme = () => setPrimaryColor(getSelectedTheme().Primary);

    updateTheme();

    window.addEventListener("storage", updateTheme);
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);

  return primaryColor
    ? `linear-gradient(180deg, ${primaryColor.start}, ${primaryColor.end})`
    : "";
};

// ================== usePrimaryTextColor ==================
export const usePrimaryTextColor = () => {
  const [primaryTextColor, setPrimaryTextColor] = useState(() => getSelectedTheme().PrimaryTextColor);

  useEffect(() => {
    const updateTheme = () => setPrimaryTextColor(getSelectedTheme().PrimaryTextColor);

    updateTheme();

    window.addEventListener("storage", updateTheme);
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);

  return primaryTextColor || "";
};

// ================== useSecondaryTextColor ==================
export const useSecondaryTextColor = () => {
  const [secondaryTextColor, setSecondaryTextColor] = useState(() => getSelectedTheme().SecondaryTextColor);

  useEffect(() => {
    const updateTheme = () => setSecondaryTextColor(getSelectedTheme().SecondaryTextColor);

    updateTheme();

    window.addEventListener("storage", updateTheme);
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);

  return secondaryTextColor || "";
};

// ================== useSecondaryColor ==================
export const useSecondaryColor = () => {
  const [secondaryColor, setSecondaryColor] = useState(() => getSelectedTheme().Secondary);

  useEffect(() => {
    const updateTheme = () => setSecondaryColor(getSelectedTheme().Secondary);

    updateTheme();

    window.addEventListener("storage", updateTheme);
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);

  return secondaryColor
    ? `linear-gradient(180deg, ${secondaryColor.start}, ${secondaryColor.end})`
    : "";
};

// ================== useGradientColor ==================
export const useGradientColor = () => {
  const [gradientColor, setGradientColor] = useState(() => getSelectedTheme().gradient);

  useEffect(() => {
    const updateTheme = () => setGradientColor(getSelectedTheme().gradient);

    updateTheme();

    window.addEventListener("storage", updateTheme);
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("storage", updateTheme);
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, []);

  return gradientColor
    ? `linear-gradient(180deg, ${gradientColor.start} 100%, ${gradientColor.end} 0%)`
    : "";
};
